import { render } from 'timeago.js';

render(document.querySelectorAll('span.timeago'));
